/**
 * Les assets de marque Next Generation, affichés en DOM.
 *
 * ⛔⛔ LA MARQUE RÉDUITE EST LE TRIANGLE, JAMAIS UN MONOGRAMME. Deux lettres
 * dans un cercle sont le réflexe par défaut de n'importe quel générateur, et ça
 * n'a rien à voir avec cette identité. Une version précédente de cette page
 * avait inventé un « NG » cursif : il n'existe pas.
 *
 * ⭐ UNE SEULE MÉTHODE DE COLORATION POUR TOUS LES ASSETS : masque CSS plus
 * `currentColor`. Les fichiers du coffre sont en noir ; changer leur `fill`
 * obligerait à les modifier dans le dépôt, donc à faire diverger la copie de
 * l'original. Le masque ne touche pas au fichier, et il permet d'hériter de la
 * couleur du contexte, ce qu'un `<img>` ne permet pas.
 *
 * ⚠️ La signature (`ng-signature.svg`) N'EST PAS VECTORIELLE : c'est un PNG
 * encodé en base64 dans un conteneur SVG, zéro `<path>`. Elle ne s'anime pas en
 * tracé et ne s'extrude pas. Le masque reste la seule façon de la recolorer, et
 * c'est précisément pour ça que la méthode est unique pour tout le monde.
 */

const ASSETS = {
  triangle: { url: '/marque/ng-triangle.svg', ratio: 481 / 557 },
  horizontal: { url: '/marque/ng-horizontal.svg', ratio: 150 / 2045 },
  vertical: { url: '/marque/ng-vertical.svg', ratio: 420 / 1318 },
  signature: { url: '/marque/ng-signature.svg', ratio: 360 / 1384 },
} as const

export function Marque({
  quoi,
  largeur,
  className = '',
  style,
}: {
  quoi: keyof typeof ASSETS
  largeur: number
  className?: string
  style?: React.CSSProperties
}) {
  const { url, ratio } = ASSETS[quoi]
  return (
    <span
      className={`marque block ${className}`}
      style={{
        width: largeur,
        height: Math.round(largeur * ratio),
        WebkitMaskImage: `url(${url})`,
        maskImage: `url(${url})`,
        ...style,
      }}
      aria-hidden
    />
  )
}
